<template>
    <b-modal v-model="modalShow" ref="modal-invoice" size="sm" title="Faturar Proposta">
        <b-form @submit="onSubmitInvoice" novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger' : validation.invoice_at != ''}">
                        <label for="invoice_at" class="bmd-label-floating">Data</label>
                        <date-picker v-model="form.invoice_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                        <label v-if="validation.invoice_at != ''" id="invoice_at-error" class="error" for="invoice_at">{{ validation.invoice_at }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group bmd-form-group"
                         v-bind:class="{'has-danger' : validation.observations != ''}">
                        <b-form-textarea
                                id="textarea"
                                v-model="form.observations"
                                placeholder="Observações..."
                                rows="3"
                                max-rows="6"
                                :state="validation.observations == ''"
                        ></b-form-textarea>
                        <label v-if="validation.observations != ''" id="observations-error" class="error" for="observations">{{ validation.observations }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-check bmd-form-group is-filled">
                        <label form="vehicle_is_new" class="bmd-label-floating">Veículo Novo?</label>
                        <b-form-checkbox
                            id="vehicle_is_new"
                            v-model="form.vehicle_is_new"
                            :value="true"
                            :unchecked-value="false">
                            {{ form.vehicle_is_new ? 'Sim': 'Não' }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-check bmd-form-group is-filled">
                        <label form="disposal_fee_is_internal" class="bmd-label-floating">Taxa de alienação interna?</label>
                        <b-form-checkbox
                            id="disposal_fee_is_internal"
                            v-model="form.disposal_fee_is_internal"
                            :value="true"
                            :unchecked-value="false">
                            {{ form.disposal_fee_is_internal ? 'Sim': 'Não' }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-check form-group bmd-form-group is-filled">
                        <label class="bmd-label-floating">Faturada em nossa loja?</label>
                        <b-form-checkbox
                                id="checkbox1"
                                v-model="form.invoice_here"
                                :value="true"
                                :unchecked-value="false">
                            {{ form.invoice_here ? 'Sim': 'Não' }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group bmd-form-group"
                        v-bind:class="{'is-filled': form.branch_where_purchased != ''}">
                        <label form="branch_where_purchased" class="bmd-label-floating">Loja onde efetuou a compra</label>
                        <input refs="branch_where_purchased" type="text" class="form-control" v-model="form.branch_where_purchased" />
                        <label v-if="validation.branch_where_purchased != ''" id="branch_where_purchased-error" class="error" for="branch_where_purchased">{{ validation.branch_where_purchased }}</label>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitInvoice" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button>
        </div>
    </b-modal>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    id: 0,
                    invoice_at: '',
                    invoice_here: false,
                    observations: '',
                    proposal_status_id: ''
                },
                modalShow: true,
                validation: {
                    invoice_at: '',
                    observations: ''
                }
            };
        },
        computed: {
            proposalStatus: {
                set(_proposalStatus) {},
                get() {
                    return this.$store.state.defaults.proposal_status;
                }
            }
        },
        async beforeMount() {
            this.$root.$emit("onLoading");
            await this.getDataProposalStatus();
            this.$root.$emit("onLoading");

        },
         mounted() {
            var self = this;

            self.form.id = self.$route.params.id;


            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        },
        methods: {
            async getDataProposalStatus() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch("defaults/proposalStatus");

                response.then(function() {
                    self.$root.$emit("onLoading");
                });

                response.catch(function() {
                    self.$root.$emit("onLoading");
                });
            },
            goBack() {
                var self = this;
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            onSubmitInvoice(_ev) {
                var self = this;
                var valid = true;

                self.validation = {
                    invoice_at: '',
                    observations: ''
                };

                if (self.form.invoice_at == '') {
                    self.validation.invoice_at = "Campo obrigatório!";
                    valid = false;
                }

                if (self.form.observations == '') {
                    self.validation.observations = "Campo obrigatório!";
                    valid = false;
                }

                const proposal_status = this.proposalStatus.filter(element => {
                    return element.name == 'Faturada'
                });

                if(proposal_status.length) {
                    this.form.proposal_status_id = proposal_status[0].id;
                } else {
                    delete this.form.proposal_status_id;
                }

                if (valid) {
                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch('proposals/edit', self.form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Proposta faturada com sucesso!");
                        self.goBack();
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                        if (err.status === 406 || err.status === 422) {
                            if (err.data.invoice_at !== undefined) {
                                self.validation.invoice_at = err.data.invoice_at[0];
                            }
                            if (err.data.observations !== undefined) {
                                self.validation.observations = err.data.observations[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            }
        }
    };
</script>